<template>
  <div class="list_one animationBox"
    @mouseenter="(e) => { this.module_isHover(e, true) }"
    @mouseleave="(e) => { this.module_isHover(e, false) }"
    :key="item.id"
    :style="{
      ...listOneStyle,
      '--seBgColor':seBgColor,
      '--mbProNameFontSize':mbProNameFontSize
    }">
    <router-link
      :to="to_link(item)"
      :target="pc_infor.target"
      class="list_one_wrap font_hover_color border_hover_color"
      :class="listArr.module_style == 3 && $store.state.app.view_pattern === 'pc' ? 'border_bottom_transition': ''"
      :style="listArr.module_style == 3 ? ({...$utils.getBackground(pc_infor.background)})  : ({...box_shadow,...$utils.getBackground(pc_infor.background)})">
      <!-- 存在图片的 0 1 2  -->
      <div class="list_img_frame" ref="animationBox" :style="imgFrameStyle" v-if="listArr.module_style !== 3">
        <div class="list_img animationImg"
          :style="{
            backgroundImage:'url('+ img_src(item) +')',
            backgroundSize: pc_infor.backgroundSize.radio_val !== 'default' ? pc_infor.backgroundSize.custom.backgroundSize : ''
          }">
          <!-- <img
            :src="item.img !== '' ? item.img : '/static/image/noimage.jpg'"
            :alt="item.name"
            :title="item.name" style="width: 100%; height: 100%; object-fit: cover;opacity: 0;"> -->
            <!-- 视频的时候 这边要添加一个icon 按钮 -->
            <i class="play-icon" v-if="item.type===5" ></i>
        </div>
      </div>
      <div class="list_content_frame" :style="contentStyle">
        <div class="product_name_wrap">
          <span class="product_name" v-text="item.relationTitle" :style="pro_name_font"></span>
        </div>
        <div class="product_summary_wrap" v-if="listArr.module_style === 2 && $store.state.app.view_pattern === 'pc'">
          <p class="product_summary" v-text="item.relationSummary"></p>
        </div>
      </div> 
    </router-link>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../../language/index'

/* 这边的编辑和删除 存在问题 要添加 编辑和删除的时候 这边 要重新写 */
//1:新闻 2:帮助 3:案例 4:下载 5:图册 11:视频
import {getBoxShadowStyle} from '@/utils/utils'
import {font_set} from '@/base/background_set';
import { delPro, deleteArtical } from '@/api/app';
export default {
  name: 'basic_recommend_list_one',
  data() {
    return {
      isHover: false,
      add_Product_isShow: false,
      detail_item: {}, // 编辑所有的信息
      showAddArticle: false
    };
  },
  props: {
    module: { //module数据
      type: Object,
      default: null
    },
    item: { // 当前循环的产品对象
      type: Object,
      default: null
    },
    hideBtn: { // 是否隐藏编辑和删除按钮
      type: Boolean,
      default: false
    },
    fromTag: { // 是否为全局搜索挂件
      type: String,
      default: ''
    }
  },
  mounted() {
    this.templet.initImageAnimation(this.img_effects, this.img_effects, this.$refs.animationBox, this.$store.state.app.view_pattern)
  },
  computed: {
    listArr() {
      return this.module.data.listArr
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor
    },
    widgets_infor() {
      return this.module.data[
      this.$store.state.app.view_pattern + "_widgets_infor"
        ];
    },
    to_link(){ // 详情的路由链接  1产品，2新闻，3帮助，4案例，5视频
      return function (item) {
        let txt = 'product'
        switch(item.type){
          case 1:
            txt = 'product';
            break;
          case 2: 
            txt = 'article';
            break;
          case 3:
            txt = 'help';
            break;
          case 4:
            txt = 'case';
            break;
          case 5:
            txt = 'video';
            break;
          default:
            txt = 'product';
            break;
        }
        return `/${txt}?id=${item.relation_id}`;
      }
    },
    contentStyle() {
      let width = ''
      let pic_Width = parseFloat(this.pc_infor.pic_size[this.pc_infor.pic_size.radio_val].width.replace('%', '')); // 图片的宽 模式2
      if (this.listArr.module_style === 2 && this.$store.state.app.view_pattern == 'pc') {
        pic_Width = 100 - pic_Width
        width = 'calc(' + pic_Width + '% - 20px)'
      }
      return {
        width: width
      }
    },
    listOneStyle() {
      let percent = 100
      let col_num = 1
      if (this.listArr.module_style !== 2) {
        col_num = this.widgets_infor.col_num[this.widgets_infor.col_num.radio_val].value
      }
      let paddingLeft = this.pc_infor.padding[this.pc_infor.padding.radio_val].paddingLeft
      let paddingTop = this.pc_infor.padding[this.pc_infor.padding.radio_val].paddingTop
      let width = 'calc(' + percent / col_num + '% - ' + paddingLeft + 'px )'
      let padding = paddingTop / 2 + 'px ' + paddingLeft / 2 + 'px '
      if (this.$store.state.app.view_pattern == 'mb') {
        if (this.listArr.module_style === 0) {
          padding = '0 1.8% 20px 1.8%'
          width = (100 - 1.8 * 2 * col_num) / col_num + '%'
          return {
            width: width,
            margin: padding
          }
        }
      } else {
        if (this.listArr.module_style !== 1) { // 0 2 3
          let detail = {}
          if (this.listArr.module_style == 3) {
            detail = {
              margin: padding
            }
          } else {
            detail = {
              padding: padding,
              'box-sizing': 'content-box'
            }
          }
          return {
            width: width,
            ...detail
            // margin: padding
          }
        } else {
          return {
            width: width,
            padding: padding
          }
        }
      }
      
    }, 
    imgFrameStyle() {
      let paddingBottom = ''
      let width = ''
      if ((this.listArr.module_style === 0 || this.listArr.module_style === 1)
        && this.pc_infor.img_size.radio_val === 'custom') {
        paddingBottom = this.pc_infor.img_size[this.pc_infor.img_size.radio_val].height
        return {
          paddingBottom: paddingBottom,
          width: width
        }
      } else if (this.listArr.module_style === 2 && this.pc_infor.pic_size.radio_val === 'custom') {
        if (this.$store.state.app.view_pattern == 'pc') {
          paddingBottom = this.pc_infor.pic_size[this.pc_infor.pic_size.radio_val].height
          width = this.pc_infor.pic_size[this.pc_infor.pic_size.radio_val].width
          return {
            paddingBottom: paddingBottom,
            width: width
          }
        }
      }
      
    },
    img_effects() {
      return this.module.data.img_effects
    },
    box_shadow() { // 阴影设置 只有PC端才能有阴影 其他的不存在
      return this.$store.state.app.view_pattern === 'pc' ? (this.isHover ? getBoxShadowStyle(this.pc_infor.boxShadow, 'hover') : getBoxShadowStyle(this.pc_infor.boxShadow)) : {}
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    },
    seBgColor() { // 悬浮背景色
      return this.pc_infor.background[this.pc_infor.background.radio_val].seColor
    },
    pro_name_font() {
      return  font_set(this.pc_infor.product_name_font)
    },
    mbProNameFontSize() { // 手机端产品标题的字号
      return  Number(this.pc_infor.product_name_font.custom.fontSize)-2 
    },
    img_src() {
      return function(item) {
        return item.relationImg ? item.relationImg: (item.type === 5 ? `${item.relationContent}?sec=1&w=600` : '/static/image/noimage.jpg')
      }
    }
  },
  methods: {
    module_isHover(e, val) {
      if (this.$store.state.app.view_pattern === 'pc' && !this.hideBtn) {
        this.isHover = val;
        if (this.isHover) {
          this.templet.enter_animation(this.img_effects, e.target, this.$store.state.app.view_pattern)
        } else {
          this.templet.leave_animation(this.img_effects, e.target)
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.list_one {
  position: relative;
  box-sizing: border-box;
  min-height: 30px;
  min-width: 30px;
  height: 100%;
  width: calc(25% - 20px);
  transition: all 0.5s ease-out;
  display: inline-block;
  // display: flex;
  text-align: center;
  box-sizing: border-box;
  // margin: 10px;
  vertical-align: top;
  // overflow: hidden;
  .tooptipPart {
    right: 0;
    bottom: 0;
    top: auto;
    display: block;
    z-index: 999;
  }

  .list_one_wrap {
    background-color: #fff;
    position: relative;
    z-index: 1;
    padding: 5%;
    display: block;
    height: 100%;
    width: 100%;
    overflow: hidden;
    color: #333;

    .list_img_frame {
      position: relative;
      padding-bottom: 100%;
      overflow: hidden;

      .list_img {
        position: absolute;
        width: 100%;
        height: 100%;
        cursor: pointer;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        // transition: all 0.36s ease;
        .play-icon {
          /* position: absolute;
          font-size: 30px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--theme_color) */
          position: absolute;
          width: 60px;
          height: 60px;
          background: url(https://sitecdn.71360.com/static/txys-001/image/backimg1.png) -116px -196px no-repeat;
          top: 50%;
          left: 50%;
          margin-top: -30px;
          margin-left: -30px;
          z-index: 2;
          cursor: pointer;
        }
      }
    }

    .list_content_frame {
      box-sizing: border-box;
      overflow: hidden;

      .product_name_wrap {
        color: inherit;
        line-height: 24px;
        white-space: normal;
        margin-bottom: 5px;
        margin-top: 15px;

        .product_name {
          color: inherit;
          font-size: 16px;
          vertical-align: middle;
          word-break: normal;
          white-space: normal;
        }
      }

      .product_prop_wrap {
        .product_props {
          padding: 0;
          margin: 0;
          list-style-type: none;
        }

        .product_prop {
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          .prop_title:after {
            content: "：";
          }

          span {
            color: #666;
            font-size: 14px;
          }
        }
      }
    }
  }

  .border_bottom_transition {
    position: relative;
    transition: 0.5s;
    border-color: transparent;
  }

  .border_bottom_transition::before {
    transform-origin: 0 100%;
    border-bottom: 3px;
    border-bottom-style: solid;
    border-color: inherit;
  }

  .border_bottom_transition::after,
  .border_bottom_transition::before {
    width: 100%;
    height: 100%;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    transition: -webkit-transform 0.36s ease;
    transition: transform 0.36s ease;
    transition: transform 0.36s ease, -webkit-transform 0.36s ease,
    -moz-transform 0.36s ease, -o-transform 0.36s ease;
  }
}

.list_one {
  .list_one_wrap {
    &.font_hover_color:hover {
      color: var(--theme_color);
    }
    &:hover{
      background-color:var(--seBgColor) !important;
      .list_content_frame{
        .product_name_wrap{
          .product_name{
             color: var(--theme_color) !important;
          }
        }
      }
    }
    
  }

  .border_hover_color:hover {
    border-color: var(--theme_color);
  }
}

.pc_pattern {
  .basic_product_display_index {
    .product_list_1 {
      .list_one {
        &:hover .list_one_wrap {
          // box-shadow: rgba(0, 0, 0, 0.1) 0 0 15px;
        }
      }
    }
  }

  .product_list_0, .product_list_2, .product_list_3 {
    .list_one {
      &:hover {
        //  box-shadow: rgba(0, 0, 0, 0.1) 0 0 15px;
      }
    }
  }

  .product_list_3 {
    .list_one {
      &:hover {
        // box-shadow: rgba(0, 0, 0, 0.1) 0 0 15px;
      }
    }
  }

  .product_list_0, .product_list_2 {
    .list_one {
      .tooptipPart {
        /* right: 10px;
        bottom: 10px; */
      }
    }

  }
}
.mb_pattern{
  .list_one {
    .list_one_wrap {
      .list_content_frame{
        .product_name_wrap{
          .product_name{
            font-size: var(--mbProNameFontSize) !important;
          }
        }
      }
      
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/widgets/basic_recommend_list/components/one_img.vue